/**
 * User-friendly hook names for the reports API.
 */

import { reportsApi } from './api';

export const {
  useGetV2ProviderReportsQuery: useReportDefinitions,
  useGetV2ProviderReportsRecentRunsQuery: useRecentRuns,
  useLazyGetV2ProviderReportsByReportKeyRunQuery: useLazyRunReport,
  useLazyExportReportCsvTextQuery: useLazyExportReportCsv,
  useLazyExportReportXlsxBlobQuery: useLazyExportReportXlsx,
  useLazyExportReportPdfBlobQuery: useLazyExportReportPdf,
  useGetV2ProviderReportsSavedViewsQuery: useSavedReportViews,
  usePostV2ProviderReportsSavedViewsMutation: useCreateSavedReportView,
  useDeleteV2ProviderReportsSavedViewsByViewIdMutation: useDeleteSavedReportView,
  useGetV2ProviderReportsCompensationConfigQuery: useCompensationConfig,
  usePutV2ProviderReportsCompensationConfigMutation: useUpdateCompensationConfig,
} = reportsApi;
